<template>
  <div class="addStoreType addCommon" style="height: 100%">
    <div class="return">
      <i class="el-icon-back" @click="goReturn">{{$t('LanguageLib.Return')}}</i>
      <span class="border"></span>
      <span class="title">{{ titleType }}</span>
    </div>
    <div class="content">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="ruleForm">
        <el-button @click="submit('ruleForm')" type="primary" class="searchBtn" style="margin-left: 0;" :loading="loadingSave">{{$t('LanguageLib.SAVE')}}</el-button>
        <p class="drawerText">{{$t('LanguageLib.SERIAL_NUMBER')}}</p>
        <el-form-item>
          <el-input
            oninput="this.value=this.value.replace(/[^\d]/g,'');"
            style="width: 320px;"
            :placeholder="$t('LanguageLib.PleaseEnter')"
            :maxlength="9"
            v-model="ruleForm.sortNo"
          >
          </el-input>
        </el-form-item>
        <p class="drawerText"><span class="colorRed">*</span>&nbsp;{{$t('LanguageLib.BRAND_NAME')}}</p>
        <el-form-item prop="brandName">
          <el-input
            maxlength="50"
            @keyup.native="btKeyUp"
            style="width: 320px;"
            :placeholder="$t('LanguageLib.PleaseEnter')"
            v-model="ruleForm.brandName"
          >
          </el-input>
        </el-form-item>
        <p class="drawerText">{{$t('LanguageLib.REMARK2')}}</p>
        <el-form-item>
          <el-input
            style="width: 320px;"
            maxlength="500"
            type="textarea"
            :rows="3"
            placeholder=""
            resize="none"
            v-model="ruleForm.description"
          >
          </el-input>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import storeinformationApi from '../../api/storeinformation'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
export default {
  data () {
    var checkBrandName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('LanguageLib.BRAND_NAME') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        if (this.$commonfun.isNull(value)) {
          return callback(new Error(this.$t('LanguageLib.BRAND_NAME') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
        } else {
          callback()
        }
      }
    }
    return {
      titleType: this.$t('LanguageLib.BRAND_INFORMATION'),
      ruleForm: {
        sortNo: '',
        brandName: '',
        description: ''
      },
      rules: {
        brandName: [
          { validator: checkBrandName, trigger: 'blur' }
        ]
      },
      loadingSave: false // 保存按钮加loding
    }
  },
  beforeRouteEnter (to, from, next) {
    NProgress.configure({
      easing: 'ease',
      speed: 500,
      showSpinner: false,
      trickleSpeed: 200,
      minimum: 0.3
    })
    NProgress.start()
    if (to.query.type === 'edit') {
      console.log()
      storeinformationApi.GetBrandDetail('get', 'store/brand/detail',
        {
          Id: JSON.parse(decodeURIComponent(to.query.data)).id
        })
        .then(res => {
          NProgress.done()
          next(vm => {
            vm.ruleForm.sortNo = res.data.sortNo === null ? '' : res.data.sortNo
            vm.ruleForm.brandName = res.data.brandNameCn
            vm.ruleForm.description = res.data.description === null ? '' : res.data.description
          })
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    } else {
      NProgress.done()
      next(vm => {
      })
    }
  },
  created () {
    // 获取品牌序号
    storeinformationApi.SortNo('get', '/store/brand/sortNo')
      .then(res => {
        if (this.$route.query.type === 'add') {
          this.ruleForm.sortNo = res.data
        }
      })
      .catch(err => {
        this.$commonfun.console.log(err)
      })
  },
  methods: {
    // 去除名称的特殊字符
    btKeyUp (e) {
      e.target.value = e.target.value.replace(/[\\/:：*?？"<>|]/g, '')
    },
    // 返回
    goReturn () {
      var fromPath = this.$route.query.type === 'add' ? 'addBrand' : 'editBrand'
      this.$router.push('/storeinformation/brandsetting?currentPage=' + this.$route.query.currentPage + '&pageSize=' + this.$route.query.pageSize + '&searchText=' + this.$commonfun.encodeUrl(this.$route.query.searchText) + '&sort=' + this.$route.query.sort + '&IsAsc=' + this.$route.query.IsAsc + '&fromPath=' + fromPath)
    },
    // 保存数据
    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.brandName = this.ruleForm.brandName.replace(/[\\/:：*?？"<>|]/g, '')
          this.loadingSave = true
          if (this.$route.query.type === 'add') {
            storeinformationApi.addStoreTypeAjax('post', '/store/brand/create', {
              BrandNameCn: this.$commonfun.trim('tail', this.ruleForm.brandName),
              SortNo: this.ruleForm.sortNo === '' ? null : this.ruleForm.sortNo * 1,
              Description: this.ruleForm.description
            })
              .then(res => {
                this.$message({
                  type: 'success',
                  message: this.$t('LanguageLib.ADDED_SUCCESSFULLY1')
                })
                var fromPath = this.$route.query.type === 'add' ? 'addBrand' : 'editBrand'
                this.$router.push('/storeinformation/brandsetting?currentPage=' + this.$route.query.currentPage + '&pageSize=' + this.$route.query.pageSize + '&searchText=' + this.$commonfun.encodeUrl(this.$route.query.searchText) + '&sort=' + this.$route.query.sort + '&IsAsc=' + this.$route.query.IsAsc + '&fromPath=' + fromPath)
                this.loadingSave = false
              })
              .catch(err => {
                this.loadingSave = false
                this.$commonfun.console.log(err)
              })
          } else {
            storeinformationApi.editStoreTypeAjax('post', '/store/brand/edit', {
              BrandNameCn: this.$commonfun.trim('tail', this.ruleForm.brandName),
              SortNo: this.ruleForm.sortNo === '' ? null : this.ruleForm.sortNo * 1,
              Description: this.ruleForm.description,
              Id: JSON.parse(decodeURIComponent(this.$route.query.data)).id
            })
              .then(res => {
                this.$message({
                  type: 'success',
                  message: this.$t('LanguageLib.EditSuccess')
                })
                var fromPath = this.$route.query.type === 'add' ? 'addBrand' : 'editBrand'
                this.$router.push('/storeinformation/brandsetting?currentPage=' + this.$route.query.currentPage + '&pageSize=' + this.$route.query.pageSize + '&searchText=' + this.$commonfun.encodeUrl(this.$route.query.searchText) + '&sort=' + this.$route.query.sort + '&IsAsc=' + this.$route.query.IsAsc + '&fromPath=' + fromPath)
                this.loadingSave = false
              })
              .catch(err => {
                this.loadingSave = false
                this.$commonfun.console.log(err)
              })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss">
.addStoreType{
  .return{
    padding-left: 25px;
    position: relative;
    height:50px;
    background:rgba(255,255,255,1);
    line-height: 50px;
    border-bottom: 1px solid #F2F2F2;
    .el-icon-back{
      margin-right: 15px;
      cursor: pointer;
    }
    .border{
      position: absolute;
      height: 37px;
      border-left: 1px solid #f1f1f1;
      display: inline-block;
      top: 5px;
    }
    .title{
      height:25px;
      font-size:18px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(0,0,0,1);
      margin-left: 15px;
    }
  }
  .content::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  .content::-webkit-scrollbar-thumb {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
    background: #E1E1E1;
  }
  .content::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
    border-radius: 5px;
    background: #fff;
  }
  .content{
    box-sizing: border-box;
    background:rgba(255,255,255,1);
    width: 100%;
    height: calc( 100% - 50px);
    overflow-y: auto;
    padding-left: 100px;
    padding-top: 15px;
    .drawerText{
      margin-bottom: 5px;
      height:16px;
      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(77,77,77,1);
      line-height:16px;
    }
  }
  // 修改按钮样式
  .el-button--primary{
    background-color: #3BC6B9;
    border-color: #3BC6B9;
    height: 30px;
    padding: 7px 20px;
    margin-bottom: 15px;
  }
  .colorRed{
    color: red;
  }
}
</style>
